import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { forkJoin } from 'rxjs';
import { BranchHttpService } from '../http/branch-http.service';
import { ProductHttpService } from '../http/product-http.service';
import { SectionHttpService } from '../http/section-http.service';

@Injectable({
    providedIn: 'root',
})
export class ProductListHttpResolverService implements Resolve<any> {
    constructor(private productHttpService: ProductHttpService, private sectionHttpService: SectionHttpService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let getAllSections = this.sectionHttpService.getAllSections();
        let getAllProducts = this.productHttpService.getAllProducts();
        return forkJoin([getAllProducts, getAllSections]);
    }
}

@Injectable({
    providedIn: 'root',
})
export class ProductEditHttpResolverService implements Resolve<any> {
    constructor(private productHttpService: ProductHttpService, private sectionHttpService: SectionHttpService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const getProductById = this.productHttpService.getProductById(route.params.id);
        const getAllSections = this.sectionHttpService.getAllSections();
        return forkJoin([getProductById, getAllSections]);
    }
}

@Injectable({
    providedIn: 'root',
})
export class ProductNewHttpResolverService implements Resolve<any> {
    constructor(private sectionHttpService: SectionHttpService) {}
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.sectionHttpService.getAllSections();
    }
}
